module.exports = __webpack_public_path__ + "img/charade-arrow-right.cea7cac3.svg";